import React, { useEffect, useRef, useState } from "react";

import { useParams, useHistory } from "react-router";

// @ts-ignore
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from "@material-ui/core/styles";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
// import GridList from "@material-ui/core/GridList";
// import GridListTile from "@material-ui/core/GridListTile";
// import Icon from "@material-ui/core/Icon";
// import Link from "@material-ui/core/Link";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import "../../../node_modules/leaflet/dist/leaflet.css";
// import "../../../node_modules/react-leaflet-markercluster/dist/styles.css";
import "../../../node_modules/react-leaflet-markercluster/dist/styles.min.css";

import "../../../node_modules/leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css";
import "../../../node_modules/leaflet-extra-markers/dist/js/leaflet.extra-markers.min.js";

import "./leaflet-custom.css";

import L from "leaflet";
import {
  Map,
  Marker,
  Popup,
  TileLayer /*, GeoJSON*/,
  // useLeaflet,
} from "react-leaflet";

import MarkerClusterGroup from "../react-leaflet-markercluster";
// import { NodeMapList } from "../node-map-list";

import { SERVER_URI } from "../../constants";

import LiveDataMapList from "./livedata-map-list";
import LiveDataMapMiniPanel from "./livedata-map-mini-panel";
import PanelCollectionSelect from "./panel-collection-select";

import useWindowSize from "../../use-window-size";

L.Icon.Default.imagePath =
  "//cdnjs.cloudflare.com/ajax/libs/leaflet/1.6.0/images/";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    avatar: {
      borderRadius: "0%",
      width: 20,
      height: 20,
    },
    horizontalList: {
      display: "flex",
      flexDirection: "row",
      padding: 0,
    },
  })
);

interface Props {
  // nodes: any[];
  // widgetStatic?: boolean;
  // widgetTitle?: string;
  bounds: any;
  items: any[];
}

// FIXME https://yuzhva.github.io/react-leaflet-markercluster/#marker-options

// TODO map height 100% (maybe based on client bounding rect)
// FIXME this is mainly copy&paste of node-map2.tsx!
// https://stackoverflow.com/questions/16845614/zoom-to-fit-all-markers-in-mapbox-or-leaflet
// TODO calc center also on client => then bounds can be removed completely!
function LiveDataMap(props: Props) {
  const classes = useStyles(props);
  const { panelCollectionName } = useParams<any>(); // TODO as props?
  const theme = useTheme() as Theme;
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [windowWidth, windowHeight] = useWindowSize();
  // console.log("window size of LiveDataMap", windowWidth, windowHeight);
  // const { nodes = [] } = props;
  const { bounds, items } = props;
  const nodes = items;
  const history = useHistory();
  const [expanded, setExpanded] = useState(new Set<string>());
  // const [zoom /*, setZoom*/] = useState(3);
  // const leaflet = useLeaflet();
  const mapRef = useRef<Map | null>();

  function onPanelCollectionChange(evt: any) {
    // console.log("onPanelCollectionChange", evt);
    history.push(`/livedata/collections/${evt /*.name*/}/map`);
  }

  function toggleExpanded(nodeId: string) {
    setExpanded(
      (previousExpanded: any) =>
        new Set(
          previousExpanded.has(nodeId)
            ? [...previousExpanded].filter((x) => x !== nodeId)
            : [...previousExpanded, nodeId]
        )
    );
  }
  const nodesWithGeo =
    nodes &&
    nodes.filter((node) => {
      return (
        node.latitude &&
        node.latitude !== 0.0 &&
        node.longitude &&
        node.longitude !== 0.0
      );
    });
  // console.log("Map nodes", nodesWithGeo);
  // TODO handle nodesWithGeo.length === 0

  const markers =
    nodesWithGeo &&
    nodesWithGeo.map((node) => {
      const coloredMarkerIcon = (L as any).ExtraMarkers.icon({
        icon: "fa-map-marker",
        markerColor: node.markerColor,
        // shape: 'square',
        prefix: "fa",
        svg: true,
      });
      const searchParams = new URLSearchParams(node.miniPanelURL.search);
      const panelCollectionName = searchParams.get("template") || "weather";

      return (
        <Marker
          key={node.id}
          position={[node.latitude, node.longitude]}
          icon={coloredMarkerIcon}
        >
          <Popup
            // autoPan={false}
            autoPan={true}
            minWidth={320}
            autoClose={false}
          >
            <Card elevation={0}>
              <CardHeader
                avatar={
                  <Avatar
                    src={`${SERVER_URI}${node.imagePath}`}
                    className={classes.avatar}
                  />
                }
                title={node.name}
                subheader={node.formattedTimeStamp}
              />
              <CardContent
                style={{ paddingBottom: "0px", paddingTop: "0px" }}
                onClick={(evt) => toggleExpanded(node.id)}
              >
                {!expanded.has(node.id) && <LiveDataMapList node={node} />}
                {expanded.has(node.id) && (
                  <LiveDataMapMiniPanel
                    node={node}
                    panelCollectionName={panelCollectionName}
                  />
                )}
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  color="primary"
                  onClick={(evt) => {
                    evt.preventDefault();
                    history.push(
                      `/livedata/collections/${panelCollectionName}/panel?node=${node.id}`
                    );
                  }}
                >
                  More...
                </Button>
                {/* <Link href={`${SERVER_URI}/livedata/collections/${panelCollectionName}/panel?node=${node.id}`}>More...</Link> */}
              </CardActions>
            </Card>
          </Popup>
        </Marker>
      );
    });

  useEffect(() => {
    if (mapRef && mapRef.current) {
      if (nodesWithGeo && nodesWithGeo.length > 0) {
        // mapRef.current.leafletElement.fitBounds([
        //   [bounds.minY, bounds.minX],
        //   [bounds.maxY, bounds.maxX],
        // ]);
        const group = (L as any).latLngBounds(
          nodesWithGeo.map((node) => [node.latitude, node.longitude])
        );
        mapRef.current.leafletElement.fitBounds(group.pad(0.5));
      }
    }
  });

  return (
    <>
      <PanelCollectionSelect
        name="panelCollectionSelect"
        label="" // "Filter"
        value={panelCollectionName}
        onChange={onPanelCollectionChange}
      />
      <Map
        center={[bounds.centerX, bounds.centerY]} // FIXME check if X and Y need to be exchanged?!
        // zoom={zoom}
        maxZoom={18}
        // FIXME set correct width/height (in parent element)!
        style={{
          width: "100%",
          // width: "98vw",
          height: windowHeight - (mobile ? 150 : 250),
          // height: "80vh",
          /*, overflow: "visible"*/
        }}
        // ref={mapRef}
        ref={(ref) => {
          mapRef.current = ref;
        }}
      >
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MarkerClusterGroup>{markers}</MarkerClusterGroup>
      </Map>
    </>
  );
}

export default LiveDataMap;
